export const CHAT_USER_MESSAGE_BUBBLE_CLASSNAME =
  'bg-primary text-primary-foreground dark:bg-secondary dark:text-secondary-foreground';

export const CHAT_ACTIVE_THREAD_CLASSNAME =
  'border-primary bg-primary text-primary-foreground dark:border-secondary dark:bg-secondary dark:text-secondary-foreground';
